import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const MenuFrameToDownload = (props: QRFRameToPrintProps): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 8 0.5 L 88 0.5 C 92.142188 0.5 95.5 3.857813 95.5 8 L 95.5 120 C 95.5 124.142188 92.142188 127.5 88 127.5 L 8 127.5 C 3.857813 127.5 0.5 124.142188 0.5 120 L 0.5 8 C 0.5 3.857813 3.857813 0.5 8 0.5 Z M 8 0.5 "
          transform="matrix(12.5,0,0,12.5,0,0)"
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 137.542969 412.542969 C 137.519531 405.621094 143.121094 400 150.042969 400 L 724.992188 400 C 731.898438 400 737.496094 405.601562 737.492188 412.507812 L 736.949219 1187.507812 C 736.945312 1194.410156 731.347656 1200 724.449219 1200 L 152.730469 1200 C 145.84375 1200 140.253906 1194.429688 140.230469 1187.542969 Z M 137.542969 412.542969 "
        />
        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameColor}
          d="M 1050.457031 1057.839844 C 1050.457031 1067.078125 1042.945312 1074.589844 1033.707031 1074.589844 L 743.664062 1074.589844 L 743.664062 932.320312 L 956.472656 932.320312 C 960.09375 932.320312 963.03125 929.382812 963.03125 925.765625 C 963.03125 922.140625 960.09375 919.203125 956.472656 919.203125 L 743.664062 919.203125 L 743.664062 813.496094 L 956.472656 813.496094 C 960.09375 813.496094 963.03125 810.5625 963.03125 806.941406 C 963.03125 803.316406 960.09375 800.382812 956.472656 800.382812 L 743.664062 800.382812 L 743.664062 694.671875 L 956.472656 694.671875 C 960.09375 694.671875 963.03125 691.738281 963.03125 688.113281 C 963.03125 684.492188 960.09375 681.554688 956.472656 681.554688 L 743.664062 681.554688 L 743.664062 575.851562 L 956.472656 575.851562 C 960.09375 575.851562 963.03125 572.910156 963.03125 569.292969 C 963.03125 565.667969 960.09375 562.730469 956.472656 562.730469 L 743.664062 562.730469 L 743.664062 457.023438 L 956.472656 457.023438 C 960.09375 457.023438 963.03125 454.089844 963.03125 450.464844 C 963.03125 446.84375 960.09375 443.910156 956.472656 443.910156 L 743.664062 443.910156 L 743.664062 391.054688 C 743.664062 390.90625 743.632812 390.765625 743.621094 390.621094 C 743.601562 390.359375 743.589844 390.097656 743.542969 389.835938 C 743.5 389.632812 743.433594 389.433594 743.375 389.234375 C 743.316406 389.027344 743.265625 388.824219 743.1875 388.628906 C 743.105469 388.425781 743 388.234375 742.898438 388.046875 C 742.804688 387.859375 742.714844 387.671875 742.605469 387.5 C 742.492188 387.324219 742.359375 387.167969 742.230469 387.007812 C 742.09375 386.835938 741.96875 386.660156 741.816406 386.503906 C 741.667969 386.351562 741.5 386.21875 741.339844 386.082031 C 741.179688 385.949219 741.027344 385.804688 740.855469 385.683594 C 740.640625 385.535156 740.40625 385.414062 740.171875 385.292969 C 740.042969 385.222656 739.933594 385.132812 739.796875 385.074219 L 493.453125 274.21875 L 1033.707031 274.21875 C 1042.945312 274.21875 1050.457031 281.734375 1050.457031 290.96875 Z M 730.546875 1181.234375 C 730.546875 1190.472656 723.035156 1197.984375 713.796875 1197.984375 L 166.292969 1197.984375 C 157.054688 1197.984375 149.542969 1190.472656 149.542969 1181.234375 L 149.542969 414.363281 C 149.542969 405.125 157.054688 397.609375 166.292969 397.609375 L 730.546875 397.609375 Z M 469.453125 277.804688 L 706.546875 384.496094 L 469.453125 384.496094 Z M 1033.707031 261.101562 L 462.894531 261.101562 C 462.746094 261.101562 462.605469 261.136719 462.453125 261.144531 C 462.195312 261.164062 461.9375 261.175781 461.679688 261.226562 C 461.46875 261.265625 461.273438 261.332031 461.070312 261.394531 C 460.867188 261.449219 460.664062 261.5 460.472656 261.578125 C 460.265625 261.660156 460.074219 261.765625 459.878906 261.867188 C 459.695312 261.964844 459.515625 262.046875 459.34375 262.160156 C 459.167969 262.273438 459.011719 262.410156 458.84375 262.539062 C 458.675781 262.671875 458.503906 262.800781 458.347656 262.949219 C 458.195312 263.097656 458.0625 263.265625 457.925781 263.425781 C 457.789062 263.589844 457.644531 263.738281 457.527344 263.910156 C 457.375 264.125 457.257812 264.359375 457.132812 264.59375 C 457.0625 264.722656 456.976562 264.835938 456.914062 264.96875 L 456.894531 265.03125 C 456.789062 265.269531 456.71875 265.527344 456.640625 265.78125 C 456.589844 265.949219 456.523438 266.113281 456.488281 266.285156 C 456.453125 266.453125 456.445312 266.628906 456.421875 266.800781 C 456.390625 267.066406 456.347656 267.332031 456.34375 267.597656 L 456.339844 267.660156 L 456.339844 384.496094 L 166.292969 384.496094 C 149.824219 384.496094 136.425781 397.890625 136.425781 414.363281 L 136.425781 1181.234375 C 136.425781 1197.703125 149.824219 1211.101562 166.292969 1211.101562 L 713.796875 1211.101562 C 730.265625 1211.101562 743.664062 1197.703125 743.664062 1181.234375 L 743.664062 1087.707031 L 1033.707031 1087.707031 C 1050.175781 1087.707031 1063.574219 1074.308594 1063.574219 1057.839844 L 1063.574219 290.96875 C 1063.574219 274.5 1050.175781 261.101562 1033.707031 261.101562 Z M 1033.707031 261.101562 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="600"
          y="1300.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
